import type { Resource } from '../../';
export const forms_error_phoneNumber_tooShort: Resource = {"default":"The phone number is too short."};
